export default __webpack_public_path__ + "static/media/bg-set-profile-visibility.124be6e7.png";